export const PostgrestApiTags = {
  USER_PROFILE: 'userProfile',
  EPISODE: 'episode',
  PLAN: 'plan',
  ORGANIZATION_PLAYLIST_EPISODES: 'organizationPlaylistEpisodes',
  PD_HOURS: 'pdHours',
  USER_TAGS: 'userTags',
  PLAYER_SESSIONS: 'playerSessions',
  PLAYER_SESSION_DETAILS: 'playerSessionDetails',
  PLAYER_CONFIG: 'playerConfig',
  USER_REGISTRATION_STATE: 'userRegistrationState',
  ORGANIZATION_MEMBERS: 'organizationMembers',
  RECOVERY_EMAIL: 'recoveryEmail',
  LISTENER_DATA: 'listenerData',
  SHOW_PRODUCT_FEEDBACK: 'showProductFeedback',
  USER_REGION: 'userRegion',
  CONTENT_PREFERENCES: 'contentPreferences',
  EPISODE_ASSESSMENT: 'episodeAssessment',
  EPISODE_QUIZZES: 'episodeQuizzes',
  ORG_PINNED_LPS: 'orgPinnedLps',
  LEARNING_PATHS: 'learningPaths',
  TRIENNIAL_SUMMARY: 'triennialSummary',
  FEATURED_EPISODES: 'featuredEpisodes',
  TRENDING_EPISODES: 'trendingEpisodes',
  NEW_EPISODES: 'newEpisodes',
  CATEGORY_EPISODES: 'categoryEpisodes',
  SEARCH_RESULTS: 'searchResults',
} as const;

export const RefetchOnMountDelay = 300;
